import config from 'SrcConfig'

export default class SettingsCore {
  constructor (store) {
    this.$store = store
    
    this._clientSettings = config.auth
  }

  get _serverSettings () {
    return this.$store.state.$settings
  }

  _throwErrorIfNull (obj, fieldName) {
    if (obj === null)
      throw new Error(`${fieldName} is null`)
  }
}
